import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

// Route guards
import ProtectedRoute from './components/ProtectedRoute';
import GuestRoute     from './components/GuestRoute';

// Layout
import AppLayout from './components/layout/AppLayout';

// Pages — Auth
import LoginPage      from './pages/auth/LoginPage';
// Pages — Dashboard
import DashboardPage  from './pages/dashboard/DashboardPage';
import GoldRatePage   from './pages/goldRate/GoldRatePage';
// Pages — Users
import UsersPage       from './pages/users/UsersPage';
import UserDetailPage  from './pages/users/UserDetailPage';
// Pages — Deposits
import DepositsPage       from './pages/investments/DepositsPage';
import DepositDetailPage  from './pages/investments/DepositDetailPage';
// Pages — Withdrawals
import WithdrawalsPage         from './pages/withdrawals/WithdrawalsPage';
import WithdrawalTransfersPage from './pages/withdrawals/WithdrawalTransfersPage';
// Pages — Banners
import BannersPage        from './pages/banners/BannersPage';
// Pages — Logo
import LogoPage           from './pages/logo/LogoPage';
// Pages — Notifications
import NotificationsPage  from './pages/notifications/NotificationsPage';
// Pages — Settings
import SettingsPage               from './pages/settings/SettingsPage';
import AdminAccountsPage          from './pages/settings/AdminAccountsPage';
import ContactSettingPage         from './pages/contact/ContactSettingPage';
import CompanyBankAccountPage     from './pages/companyBankAccount/CompanyBankAccountPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Guest-only routes */}
          <Route element={<GuestRoute />}>
            <Route path="/login" element={<LoginPage />} />
          </Route>

          {/* Protected admin routes — wrapped in AppLayout */}
          <Route element={<ProtectedRoute />}>
            <Route element={<AppLayout />}>
              <Route path="/dashboard"     element={<DashboardPage />} />
              <Route path="/users"           element={<UsersPage />} />
              <Route path="/users/:id"       element={<UserDetailPage />} />
              <Route path="/investments"     element={<DepositsPage />} />
              <Route path="/deposits/:id"    element={<DepositDetailPage />} />
              <Route path="/withdrawals"              element={<WithdrawalsPage />} />
              <Route path="/withdrawal-transfers"    element={<WithdrawalTransfersPage />} />
              <Route path="/notifications"  element={<NotificationsPage />} />
              <Route path="/gold-rate"      element={<GoldRatePage />} />
              <Route path="/banners"        element={<BannersPage />} />
              <Route path="/logo"           element={<LogoPage />} />
              <Route path="/settings"              element={<SettingsPage />} />
              <Route path="/admin-accounts"       element={<AdminAccountsPage />} />
              <Route path="/contact-info"         element={<ContactSettingPage />} />
              <Route path="/company-bank-account" element={<CompanyBankAccountPage />} />
            </Route>
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
